import "./Contacts.scss"

export default function Contacts() {
  return (
    <div>
      <div className="contacts">
        <div className="contacts__left">
          <h1 className="contacts__heading">
            Contacts
            <br />
            Collaborate
            <br />
            Anytime
          </h1>

          <div className="contacts__socials">
            <h3>SOCIALS</h3>
            <ul>
              <li>
                <a href="https://x.com/var11able" target="_blank" rel="noopener noreferrer">Twitter/X</a>
              </li>
              <li>
                <a href="https://www.facebook.com/ishvarqse/" target="_blank" rel="noopener noreferrer">Facebook</a>
              </li>
              <li>
                <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">Instagram</a>
              </li>

            </ul>
          </div>

        </div>

        <div className="contacts__right">
          <div className="contacts__numbers">
            <div className="contacts__region">
              <h3>PHONE</h3>
              <a href="tel:" target="_blank" rel="noopener noreferrer">+62 something idk</a>
            </div>

            <div className="contacts__region">
              <h3>GMAIL</h3>
              <a href="mailto:ishvarapranidhanakeys@gmail.com" target="_blank" rel="noopener noreferrer">ishvar11able@gmail.com</a>
            </div>

            <div className="contacts__region">
              <h3>OUTLOOK</h3>
              <a href="mailto:ishvarapranidhanakeys@outlook.com" target="_blank" rel="noopener noreferrer">ishvar11able@outlook.com</a>
            </div>

            {/* <div className="contacts__region">
              <h3>ASIA (CHN)</h3>
              <a href="tel:+8613795311193">+86 (137) 9531 1193</a>
            </div> */}
          </div>

          <div className="contacts__email">
            <h3>Join my Discord server?</h3>
            <a href="https://discord.gg/3m2x6pyZpx" target="_blank" rel="noopener noreferrer">Varchive</a>
          </div>
        </div>
      </div>
      <div className="footer">
        <p>&copy; 2025 Var11able. All rights reserved.</p>
        <p><a href="https://github.com/var11able" target="_blank" rel="noopener noreferrer">GitHub</a></p>
      </div>
    </div>

  )
}

